module.exports = __webpack_public_path__ + "media/images/area/feature/kansai/related/zh-hant/6-7aca986f8f91baac7a303bc79701bb90.jpg";